<template>
  <div class="with-ledger">
    <div class="pl-3 pr-3 pt-5 pb-5">
      <div class="text-2 text-center">Connect Ledger</div>
      <div class="mt-5 pl-5 pr-5">
        <div class="pl-5 pr-5">
          <v-progress-linear
            color="primary"
            height="8px"
            :value="50"
            :buffer-value="100"
            :reverse="step === 2"
            rounded
          ></v-progress-linear>
        </div>
      </div>
      <div class="text-4 d-flex justify-space-around mt-2">
        <div>Ledger App</div>
        <div>Wallet Address</div>
      </div>
      <br />
      <deriviation-path
        v-if="step === 1"
        @selectHdPath="selectHdPath"
        :project="project"
      />
      <wallet-address
        v-if="step === 2"
        :hdPath="hdPath"
        :project="project"
        @next="connectWallet"
        @cancel="$emit('cancel')"
        @onError="onError"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DeriviationPath from "./DeriviationPath";
import WalletAddress from "./WalletAddress";

export default {
  name: "WithLedger",
  props: ["project"],
  components: {
    DeriviationPath,
    WalletAddress,
  },
  data: () => ({
    step: 0,
    hdPath: null,
    connecting: false,
  }),
  computed: mapGetters({
    isLedgerSupported: "appConfig/isLedgerSupported",
  }),
  methods: {
    selectHdPath(item) {
      this.hdPath = item;
      this.step = 2;
    },
    connectWallet(address, { hdPath }) {
      this.connecting = true;
      this.$emit("next", address, { hdPath });
    },
    onError(error) {
      this.$emit("onError", error);
    },
  },
  mounted() {
    if (!this.isLedgerSupported) {
      const error = new Error(
        `WebUSB browser support is needed for Ledger. Please use Chrome, Opera or Brave with WebUSB enabled. Also make sure you're on an HTTPS connection.`
      );
      return this.onError(error);
    }
    this.step = 1;
  },
};
</script>
